import { LOCALE_CHANGE } from './localeActionTypes';

// eslint-disable-next-line import/prefer-default-export
export const localeChange = (locale) => async (dispatch, getState) => {
    //console.log(locale);
    //type: LOCALE_CHANGE,
    //locale,
    dispatch({ type: LOCALE_CHANGE, payload: locale });
};
